<h2 mat-dialog-title>
  {{ 'INBOX.REQUEST_PAYMENT.TITLE' | translate }}
</h2>
<mat-dialog-content [formGroup]="paymentLinkForm">
  <label>
    {{ 'INBOX.REQUEST_PAYMENT.FORM_LABEL' | translate }}
  </label>
  <ng-container formArrayName="lineItems">
    <ng-container *ngFor="let lineItemForm of lineItems.controls; let idx = index">
      <glxy-form-row [formGroup]="lineItemForm">
        <glxy-form-field size="small" class="col-xs-12 col-sm-6">
          <input
            matInput
            formControlName="description"
            placeholder="{{ 'INBOX.REQUEST_PAYMENT.ITEM_DESCRIPTION' | translate }}"
          />
        </glxy-form-field>
        <glxy-form-field size="small" class="col-xs-12 col-sm-4">
          <span matPrefix>&nbsp;&nbsp;{{ currencySymbol }}</span>
          <input (focusout)="calculateSubTotalAndTax()" matInput formControlName="amount" placeholder="Amount" />
        </glxy-form-field>
        <glxy-form-field size="small" class="col-xs-12 col-sm-1 delete-field">
          <button mat-icon-button *ngIf="idx > 0" (click)="deleteLineItemAndCalculate(idx)">
            <mat-icon class="delete-btn">delete_forever</mat-icon>
          </button>
        </glxy-form-field>
      </glxy-form-row>
    </ng-container>
  </ng-container>
  <glxy-form-row>
    <glxy-form-field size="small" class="col-xs-12 col-sm-4">
      <button mat-stroked-button color="primary" (click)="addLineItem()">
        <mat-icon>add</mat-icon>
        {{ 'INBOX.REQUEST_PAYMENT.ADD_ITEM' | translate }}
      </button>
    </glxy-form-field>
    <glxy-form-field size="small" class="col-xs-12 col-sm-6">
      <div class="create-payment-link-totals">
        <div>
          {{ 'INBOX.REQUEST_PAYMENT.SUBTOTAL' | translate }}
          {{ subTotal / CENTS_PER_DOLLAR | currency: currencyCode:true:DIGITS_INFO }}
        </div>
        <ng-container *ngIf="showTaxCalculation">
          <div>
            {{ 'INBOX.REQUEST_PAYMENT.TAX' | translate }}
            {{ tax / CENTS_PER_DOLLAR | currency: currencyCode:true:DIGITS_INFO }}
          </div>
          <div>
            <a href="/billing/taxes" target="_blank">
              {{ 'INBOX.REQUEST_PAYMENT.CONFIGURE_TAX_RATES' | translate }}
              <mat-icon class="tax-info-icon" matTooltip="{{ 'INBOX.REQUEST_PAYMENT.TAX_TOOLTIP' | translate }}">
                info
              </mat-icon>
            </a>
          </div>
        </ng-container>
        <div>
          {{ 'INBOX.REQUEST_PAYMENT.TOTAL' | translate }}
          {{ (subTotal + tax) / CENTS_PER_DOLLAR | currency: currencyCode:true:DIGITS_INFO }}
        </div>
      </div>
    </glxy-form-field>
    <glxy-form-field size="small" class="col-xs-12 col-sm-1 delete-field"></glxy-form-field>
  </glxy-form-row>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="create-payment-link-actions">
    <button mat-stroked-button mat-dialog-close>{{ 'INBOX.REQUEST_PAYMENT.CANCEL' | translate }}</button>
    <button mat-flat-button color="primary" (click)="requestPayment()">
      {{ 'INBOX.REQUEST_PAYMENT.CREATE' | translate }}
    </button>
  </div>
</mat-dialog-actions>
